import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0074',
    ecrans: ['00-2'],
    params: [ 'id', '?daccleint','?dcncleint']
});

